var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('video',{ref:"videoRef",staticClass:"playlist-slide-video",style:({
    objectFit: _setup.imageMode,
    visibility: _setup.show ? 'visible' : 'hidden',
    zIndex: _setup.show ? 10 : 0,
  }),attrs:{"loop":"","muted":"","texture":"","poster":_setup.isAndroid && _setup.thumbnailUrl ? _setup.thumbnailUrl : undefined},domProps:{"muted":true},on:{"posterror":_setup.handlePosterError}},[_c('source',{attrs:{"src":_setup.videoUrl,"type":_setup.itemType},on:{"error":_setup.handleVideoError}}),(!_setup.isWeb)?_c('source',{attrs:{"src":_setup.defaultVideoUrl,"type":_setup.itemType},on:{"error":_setup.handleDefaultVideoError}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }